export enum FilterIconName {
  Filter = 'Filter',
}

export const filterIconAssets: {[key in FilterIconName]: string} = {
  [FilterIconName.Filter]: require('./ic-filter.svg'),
};
